import React from "react"
import { BadgeTemplate, PrinterModel } from "sharedTypes/badge"
import BrotherDimensionsForm from "./BrotherDimensionsForm"
import GenericDimensionsForm from "./GenericDimensionsForm"

type Props = {
  template: BadgeTemplate
  onWidthChange: (width: number) => void
  onHeightChange: (height: number) => void
  onInputKeyDown?: (e: React.KeyboardEvent) => void
  orientation?: "parallel" | "perpendicular"
  onOrientationChange?: (orientation: "parallel" | "perpendicular") => void
  isDisabled?: boolean
}

const BadgeDimensionsForm = ({
  template,
  onWidthChange,
  onHeightChange,
  onInputKeyDown,
  orientation,
  onOrientationChange,
  isDisabled = false,
}: Props) => {
  switch (template.printerModel) {
    case PrinterModel.QL_810_820_SERIES:
      return (
        <BrotherDimensionsForm
          template={template}
          onWidthChange={onWidthChange}
          onHeightChange={onHeightChange}
          onInputKeyDown={onInputKeyDown}
          orientation={orientation}
          onOrientationChange={onOrientationChange}
          isDisabled={isDisabled}
        />
      )

    case PrinterModel.GENERIC:
      return (
        <GenericDimensionsForm
          template={template}
          onWidthChange={onWidthChange}
          onHeightChange={onHeightChange}
          isDisabled={isDisabled}
        />
      )
    default: {
      const unhandledPrinterModel: never = template.printerModel
      throw new Error(`Unhandled printer model: ${unhandledPrinterModel}`)
    }
  }
}

export default BadgeDimensionsForm
